import axios from 'axios';
import get from 'lodash/get';
import { getJwtToken } from '../../services/auth';

import { Amplify } from '@aws-amplify/core';
import config from '../../config';

Amplify.configure(config);

/**
 * CRCE technical heat profile API only (e.g. PQT import bulk-upload).
 * Do not use for general Heat Profile screens — those use heatProfileAxiosConfig.
 */
const baseURL = String(process.env.REACT_APP_AWS_CRCE_TECHNICAL_HEAT_PROFILE || '').replace(/\/?$/, '/');

const crceTechnicalHeatProfileAxios = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const handleErroredResponse = async (error) => {
  const originalRequest = get(error, ['response', 'config'], undefined);
  const statusCode = get(error, ['response', 'status'], undefined);
  const errMessage = get(error, ['response', 'data', 'name'], undefined);
  const errData = get(error, ['response', 'data'], undefined);

  if (statusCode === 401) {
    if (errMessage === 'TokenExpiredError') {
      const token = await getJwtToken();
      if (token) {
        axios.defaults.headers.common['Authorization'] = token;
      }
      return crceTechnicalHeatProfileAxios(originalRequest);
    }
  }

  if (errData) {
    return Promise.reject(errData);
  }
  return Promise.reject(error.message);
};

crceTechnicalHeatProfileAxios.interceptors.request.use(
  async (config) => {
    const aConfig = config;
    const authToken = await getJwtToken();
    if (authToken) {
      aConfig.headers['Authorization'] = authToken;
    }
    return aConfig;
  },
  (error) => Promise.reject(error)
);

crceTechnicalHeatProfileAxios.interceptors.response.use(
  (response) => response,
  async (error) => handleErroredResponse(error)
);

export default crceTechnicalHeatProfileAxios;
